import { apiRequest } from "utils/api";
import { persistor, AppDispatch } from "store";
import { CREATE_SESSION_FAILURE, CREATE_SESSION_SUCCESS, DELETE_SESSION_SUCCESS } from "store/reducers/types/session";
import { setRecruiterIds } from 'store/actions/dashboard';

export const purgePersistor = (): void => {
  persistor.pause();
  persistor.flush().then(() => {
    return persistor.purge();
  });
  persistor.persist();
};

export const createSession = (code: string, previousUserId: number): any => {
  return async (dispatch: AppDispatch) => {
    if (!code) {
      dispatch({ type: CREATE_SESSION_FAILURE });
    }

    try {
      const response = await apiRequest("post", "auth/getAccessToken", {
        data: { code },
      });

      if (previousUserId !== response.data.user.userID) {
        purgePersistor();
        setRecruiterIds([]);
      };

      dispatch({
        type: CREATE_SESSION_SUCCESS,
        contents: response.data,
      });

      localStorage.setItem("accessToken", response.data.accessToken);
      localStorage.setItem("refreshToken", response.data.refreshToken);

      return response?.data || {};
    } catch (response) {
      dispatch({ type: CREATE_SESSION_FAILURE });
      localStorage.removeItem("accessToken");
      throw response;
    }
  };
}

export const renewAccessToken = (): any => {
  return async (dispatch: AppDispatch) => {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      dispatch({ type: CREATE_SESSION_FAILURE });
    }

    try {
      const response = await apiRequest("post", "auth/renewAccessToken", {
        data: { refreshToken },
      }, false);

      purgePersistor();

      dispatch({
        type: CREATE_SESSION_SUCCESS,
        contents: response?.data || {}
      });

      localStorage.setItem("accessToken", response.data.accessToken);
      localStorage.setItem("refreshToken", response.data.refreshToken);

      return response?.data || {};
    } catch (response) {
      dispatch({ type: CREATE_SESSION_FAILURE });
      throw response;
    }
  };
}

export const deleteSession = (): any => {
  return (dispatch: AppDispatch) => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    //purgePersistor();

    dispatch({ type: DELETE_SESSION_SUCCESS });
  };
}
